function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import theme from '@adsk/alloy-react-theme';
export const BADGE_VARIANTS = {
  SOLID: 'solid',
  OUTLINE: 'outline',
  LINE: 'line'
};
export const BADGE_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
const DEPRECATED_BADGE_COLORS = {
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  BLUE: theme.colors.adskBlue500,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  GREEN: theme.colors.green500,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  RED: theme.colors.red500,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  PURPLE: theme.colors.purple500,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  YELLOW: theme.colors.yellowOrange500,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  GRAY: theme.colors.charcoal900,
  /**
   * @deprecated Use non-color specific option
   * @example <Badge color={Badge.COLORS.OPEN} />
   * */
  GRAY_200: theme.colors.charcoal200
};
export const BADGE_COLORS = _objectSpread(_objectSpread({}, DEPRECATED_BADGE_COLORS), {}, {
  DEFAULT: theme.tokens.colors.background.accent.six.bold.value,
  OPEN: theme.tokens.colors.background.open.value,
  REVIEW: theme.tokens.colors.background.review.value,
  PENDING: theme.tokens.colors.background.pending.value,
  DRAFT: theme.tokens.colors.background.draft.value,
  POSITIVE: theme.tokens.colors.background.success.value,
  NEGATIVE: theme.tokens.colors.background.error.value,
  CLOSED: theme.tokens.colors.background.closed.value,
  REMOVED: theme.tokens.colors.background.removed.value
});
//# sourceMappingURL=consts.js.map